import { animation } from '@zipdrug/ui';

const activeCallAnimation = animation.build({
  duration: 1500,
  iterationCount: 'infinite',
  name: animation.wobble,
});

export default activeCallAnimation;
